<div class="register-container">
  <h2>Potwierdzenie adresu e-mail</h2>
  @if (errorMessage) {
    <div class="error-message">
      {{ errorMessage }}
    </div>
  }
</div>